import { API, authClient } from "../index";

// Get all categoriasEstablecimientos
export const getCategoriasEstablecimientos = () => {
  return authClient().get(`${API}/categoriaEstablecimiento?getDisabled=true`);
};

// Get categoriaEstablecimiento by id
export const getCategoriaEstablecimientoById = (id) => {
  return authClient().get(`${API}/categoriaEstablecimiento/${id}`);
};
